<div style="height: 100%;">
    <!-- <app-bread-crumb [elements]="routeList"></app-bread-crumb> -->
    <app-widget-form [notDialog]="true"></app-widget-form>
</div>